(function () {
  var root = document.getElementById("vs-popup-widget-root");
  if (!root) return;
  var appUrl = (root.dataset.appUrl || "").replace(/\/$/, "");
  var STORAGE_KEY = "vs_popup_last_shown";
  var TEST_MODE =
    new URLSearchParams(window.location.search).get("vs_popup_test") === "1";

  function shouldShow(cooldownHrs) {
    if (TEST_MODE) return true;
    var last = localStorage.getItem(STORAGE_KEY);
    if (!last) return true;
    var elapsed = (Date.now() - parseInt(last, 10)) / 3600000;
    return elapsed >= (cooldownHrs || 24);
  }

  function markShown() {
    if (TEST_MODE) return;
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
  }

  function dismiss(overlay) {
    overlay.classList.remove("vs-popup-open");
    setTimeout(function () {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }, 320);
  }

  /* ── shared content builder ── */
  function buildContent(popup, container) {
    var tc = popup.textColor || "#ffffff";
    var bc = popup.bgColor || "#111111";

    // Close button
    var closeBtn = document.createElement("button");
    closeBtn.className = "vs-popup-close";
    closeBtn.setAttribute("aria-label", "ปิด");
    closeBtn.innerHTML = "&times;";
    closeBtn.style.color = tc;
    closeBtn.onclick = function () {
      dismiss(container.closest(".vs-popup-overlay"));
    };
    container.appendChild(closeBtn);

    // Title
    if (popup.title) {
      var titleEl = document.createElement("p");
      titleEl.className = "vs-popup-title";
      titleEl.textContent = popup.title;
      container.appendChild(titleEl);
    }

    // Body
    if (popup.body) {
      var bodyEl = document.createElement("p");
      bodyEl.className = "vs-popup-body";
      bodyEl.textContent = popup.body;
      container.appendChild(bodyEl);
    }

    // CTA
    if (popup.ctaText) {
      var cta = document.createElement("a");
      cta.href = popup.ctaLink || "#";
      cta.className = "vs-popup-cta";
      cta.textContent = popup.ctaText;
      cta.style.background = tc;
      cta.style.color = bc;
      container.appendChild(cta);
    }
  }

  function render(popup) {
    var layout = popup.layout || "text_only";
    var hasImage = !!(
      popup.imageUrl &&
      (layout === "image_left" || layout === "image_top")
    );

    var overlay = document.createElement("div");
    overlay.className = "vs-popup-overlay";

    var box = document.createElement("div");
    box.className = "vs-popup-box" + (hasImage ? " vs-popup-" + layout : "");
    box.style.background = popup.bgColor || "#111111";
    box.style.color = popup.textColor || "#ffffff";

    if (hasImage && layout === "image_left") {
      /* ── Split: image left, content right ── */
      box.style.padding = "0";
      box.style.overflow = "hidden";

      var imgPanel = document.createElement("div");
      imgPanel.className = "vs-popup-img-panel";
      var img = document.createElement("img");
      img.src = popup.imageUrl;
      img.alt = "";
      img.className = "vs-popup-img";
      imgPanel.appendChild(img);
      box.appendChild(imgPanel);

      var contentPanel = document.createElement("div");
      contentPanel.className = "vs-popup-content";
      buildContent(popup, contentPanel);
      box.appendChild(contentPanel);
    } else if (hasImage && layout === "image_top") {
      /* ── Image top, content below ── */
      box.style.padding = "0";
      box.style.overflow = "hidden";
      box.style.textAlign = "center";

      var imgTop = document.createElement("img");
      imgTop.src = popup.imageUrl;
      imgTop.alt = "";
      imgTop.className = "vs-popup-img-top";
      box.appendChild(imgTop);

      var contentBelow = document.createElement("div");
      contentBelow.className = "vs-popup-content";
      buildContent(popup, contentBelow);
      box.appendChild(contentBelow);
    } else {
      /* ── Text only (original) ── */
      buildContent(popup, box);
    }

    overlay.appendChild(box);
    document.body.appendChild(overlay);

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) dismiss(overlay);
    });

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.add("vs-popup-open");
      });
    });

    markShown();
  }

  function init() {
    // In test mode: wait 1.2s so any in-flight admin save can propagate before we fetch
    var fetchDelay = TEST_MODE ? 1200 : 0;

    setTimeout(function () {
      doFetch();
    }, fetchDelay);
  }

  function doFetch() {
    var ctrl = new AbortController();
    var timer = setTimeout(function () {
      ctrl.abort();
    }, 5000);

    var apiUrl =
      appUrl + "/api/storefront/popup" + (TEST_MODE ? "?test=1" : "");

    fetch(apiUrl, { signal: ctrl.signal })
      .then(function (r) {
        clearTimeout(timer);
        return r.json();
      })
      .then(function (data) {
        var popup = data && data.popup;
        if (!popup) return;
        if (!shouldShow(popup.cooldownHrs)) return;

        var delay = TEST_MODE
          ? 0
          : Math.max(0, parseInt(popup.showDelay, 10) || 3) * 1000;
        setTimeout(function () {
          render(popup);
        }, delay);
      })
      .catch(function () {});
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
